export default __webpack_public_path__ + "static/media/artifact.9a44ec3e.svg";